



































































































import {
  Vue,
  Component,
  Prop,
} from "@/shared/vuepack";
import {
  InvestmentManagementType,
  DrivewealthWizardStep,
  DrivewealthAccountSummary,
  DrivewealthAccountManagementType,
  FeatureFlags
} from "@/shared/types";
import moment from "moment";
import _ from "lodash";
import InvestmentAccountTypeSlots from "@/shared/components/investments/drivewealth/InvestmentAccountTypeSlots.vue";
import { Validator } from "vee-validate";
import { formatCurrency } from "@/shared/currency";
import * as RouteNames from "@/employee/route-names";
import { AccountType } from "@/shared/custodianSettings/drivewealthTypes";
import WizardProgress from "@/employee/components/investments/drivewealth/wizard/WizardProgress.vue";
import { useEnrollmentStore } from "@/employee/store/enrollment";
import { useDrivewealthWizardStore } from "@/shared/store/drivewealthWizard";
import { useDrivewealthStore } from "@/shared/store/drivewealth";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import { hasQuarterlyFee, quarterlyFee } from "@/shared/quarterlyFeesHelper";

@Component({
  components: {
    InvestmentAccountTypeSlots,
    WizardProgress
  }
})
export default class InvestmentAccountTypeSelector extends Vue {
  $validator: Validator;
  InvestmentManagementType = InvestmentManagementType;
  formatCurrency = formatCurrency;
  quarterlyFee = quarterlyFee;
  hasQuarterlyFee = hasQuarterlyFee;

  @Prop({ required: true })
  isUserOnboarding: boolean;

  @Prop()
  isWizard: boolean;

  @Prop()
  isPreEnrollment: boolean;

  enrollmentStore = useEnrollmentStore();
  drivewealthWizardStore = useDrivewealthWizardStore();
  drivewealthStore = useDrivewealthStore();
  featureFlagStore = useFeatureFlagStore();


  mounted (): void {
    this.enrollmentStore.loadFees();
    this.drivewealthWizardStore.loadBalanceAndIsAllowedToPreenroll({});
    if (this.featureFlagStore.flags.bend15911EnableDrivewealthMultiAccountViews && !this.isPreEnrollment) {
      this.drivewealthStore.loadAccountSummariesV2({});
    }
  }

  get step () {
    return DrivewealthWizardStep.SelectAccountType;
  }

  get isAccountSummariesV2Loaded () {
    let isLoaded = true;
    if (this.featureFlagStore.flags.bend15911EnableDrivewealthMultiAccountViews && !this.isPreEnrollment) {
      isLoaded = this.drivewealthStore.accountSummariesV2Loaded;
    }
    return isLoaded;
  }

  get learnMore () {
    const name = this.isUserOnboarding ? RouteNames.DrivewealthLearnMoreOnboarding : RouteNames.DrivewealthLearnMorePages;

    return {
      name,
      params: {
        subpage: "list"
      }
    };
  }

  anchorClasses (isDisabled: boolean) {
    return {
      "d-flex": true,
      "align-items-center": true,
      "jumbotron-link-container": true,
      "disabled": isDisabled
    };
  }

  setAccountType (accountType: string, isDisabled: boolean) {
    if (!isDisabled) {
      this.drivewealthWizardStore.selectAccountType(accountType as AccountType);
    }
  }

  get formattedDateNow (): string {
    return moment().format("MMM DD");
  }

  get advisoryAccount (): DrivewealthAccountSummary {
    const account = _.find(this.drivewealthStore.accountSummariesV2,
      x => x.accountManagementType === DrivewealthAccountManagementType.Advisory);

    return account;
  }

  get hasAdvisoryAccount (): boolean {
    return this.advisoryAccount !== undefined;
  }

  get openBrokerageAccount (): DrivewealthAccountSummary {
    const account = _.find(this.drivewealthStore.accountSummariesV2,
      x => x.accountManagementType === DrivewealthAccountManagementType.OpenBrokerage);

    return account;
  }

  get hasOpenBrokerageAccount (): boolean {
    return this.openBrokerageAccount !== undefined;
  }

  get managedAccount (): DrivewealthAccountSummary {
    const account = _.find(this.drivewealthStore.accountSummariesV2,
      x => x.accountManagementType === DrivewealthAccountManagementType.RiaManaged);

    return account;
  }

  get hasManagedAccount (): boolean {
    return this.managedAccount !== undefined;
  }
}
